import { ButtonProps } from '@mui/material';
import React from 'react';
import { withTracking } from '../../../Services/Monitoring/ApplicationInsights';
import { ButtonType } from '../../../SharedComponents/Button/ButtonType';
import CustomButton from '../../../SharedComponents/Button/CustomButton';
import PairButton from '../../../SharedComponents/Button/PairButton';
import AppContainer from '../../../SharedComponents/Container/AppContainer';
import BodyContainer from '../../../SharedComponents/Container/BodyContainer';
import Header from '../../../SharedComponents/Header/HeaderRefactor';
import { StepContentType } from '../../../SharedComponents/Stepper/StepperModel';
import VerticalStepper from '../../../SharedComponents/Stepper/VerticalStepper';
import CustomTypography, {
    TypographyType,
} from '../../../SharedComponents/Typography/CustomTypography';
import useUserJourneyHandler from './UserJourneyPageHandlerHook';
import useUserJourneyResource from './UserJourneyPageResourceHook';
import PartialDialog from '../../../SharedComponents/Dialog/PartialDialog/PartialDialog';

function UserJourneyPage() {
    const {
        useWarningDialogHandler,
        activeStep,
        showStartOver,
        onResume,
        warningDisplayed,
    } = useUserJourneyHandler();

    const {
        useWarningDialogResource,
        header,
        stepContents,
        buttonLabels,
        informationText,
    } = useUserJourneyResource(activeStep);

    const primButtonConfig: ButtonProps = {
        id: buttonLabels.primary.id,
        children: buttonLabels.primary.label,
        onClick: onResume,
    };

    return (
        <AppContainer>
            <PartialDialog
                open={warningDisplayed}
                useHandler={useWarningDialogHandler}
                useResource={useWarningDialogResource}
            />
            <Header headerContent={header} />
            <BodyContainer flexStart>
                <VerticalStepper
                    activeStep={activeStep}
                    stepContentType={StepContentType.IconStepper}
                    stepContents={stepContents}
                    showActiveStepText={false}
                    showCompletedStepIcon={true}
                />
                <CustomTypography
                    id={informationText.id}
                    text={informationText.text}
                    type={TypographyType.notoSansBody14px}
                    className="userJourneyInformationText"
                ></CustomTypography>
            </BodyContainer>
            {buttonLabels.secondary ? (
                <PairButton
                    withLoading
                    secondaryButton={{
                        id: buttonLabels.secondary.id,
                        onClick: showStartOver,
                        children: buttonLabels.secondary.label,
                    }}
                    primaryButton={primButtonConfig}
                />
            ) : (
                <CustomButton
                    buttonType={ButtonType.Primary}
                    {...primButtonConfig}
                />
            )}
        </AppContainer>
    );
}

export default withTracking(UserJourneyPage);
